export default __webpack_public_path__ + "static/media/tpc_healthcare.6c7d100e.svg";